/**
 * KAN-955: "Работа идёт" у строк "Нет движения" (причина внимания idle, KAN-907).
 * Работа с клиентом идёт, просто долго: менеджер убирает строку, не закрывая
 * сделку. Backend ставит метку, и клиент уходит из сигнала на IDLE_DAYS дней.
 * Одно правило кнопки для блока "Требуют внимания", таблицы и панели CRM и
 * приложения менеджера /m: действие work_continues есть только у строки с idle.
 */
import type { AttentionAction } from '@/services/api/dashboard';

export const WORK_CONTINUES: AttentionAction = 'work_continues';
export const WORK_CONTINUES_LABEL = 'Работа идёт';
/** Тост после отметки. */
export const WORK_CONTINUES_TEXT = 'Отмечено: работа идёт';

/**
 * Строка сейчас с причиной "Нет движения": reasons элемента внимания или флаг
 * idle строки CRM (backend, crm_board._row).
 */
export function isIdleRow(item: { reasons?: readonly string[]; idle?: boolean } | null | undefined): boolean {
  return !!item && (item.idle === true || !!item.reasons?.includes('idle'));
}

/** Набор кнопок строки с "Работа идёт" у строки с idle. */
export function withWorkContinues(actions: readonly AttentionAction[], idle: boolean): readonly AttentionAction[] {
  return idle && !actions.includes(WORK_CONTINUES) ? [...actions, WORK_CONTINUES] : actions;
}
